import type NativeadsUpsellEffectState from "./schema/NativeadsUpsellEffectState";
import { createStore } from "owa-satcheljs";

const nativeadsUpsellEffectState: NativeadsUpsellEffectState = {
    isEffective: false,
};

const defaultExport: () => NativeadsUpsellEffectState = createStore<NativeadsUpsellEffectState>("nativeadsUpsellEffectState", nativeadsUpsellEffectState);
export default defaultExport;
